import { render, staticRenderFns } from "./SingleClientView.vue?vue&type=template&id=f62c051a&scoped=true"
import script from "./SingleClientView.vue?vue&type=script&lang=js"
export * from "./SingleClientView.vue?vue&type=script&lang=js"
import style0 from "./SingleClientView.vue?vue&type=style&index=0&id=f62c051a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62c051a",
  null
  
)

export default component.exports